import { Component, OnInit } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'
import * as _ from 'lodash'
import { MenuService } from 'src/app/services/ui-components/menu.service'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { MenuTopSecondNotifyService } from '../menu-top-second/menu-top-second-notify.service'
import { InstalledModule } from '../../../../../models/login-response.model'

@Component({
    selector: 'app-menu-top',
    templateUrl: './menu-top.component.html',
    styleUrls: ['./menu-top.component.scss'],
    standalone: false
})
export class MenuTopComponent implements OnInit {
  private _menuData: any[]
  private _menuDataChildrenActivated: any[]
  private readonly role: string
  private readonly modules: InstalledModule[] = []

  public childrenOfChildren: any[] = []

  public get menuDataChildrenActivated(): any[] {
    return this._menuDataChildrenActivated
  }

  constructor(
    private menuService: MenuService,
    private basicAuthService: BasicAuthService,
    private menuNotifyService: MenuTopSecondNotifyService,
    private router: Router,
  ) {
    this.role = this.basicAuthService.getUserRole()
    this.modules = this.basicAuthService.getModules()
  }

  public hasAccess(item: any): boolean {
    return (
      this.hasAccessByRole(this.getRoles(item)) && this.hasAccessByModules(this.getModules(item))
    )
  }

  public display(item: any): boolean {
    return this.displayByModule(this.getModules(item))
  }

  private displayByModule(modules: { name: string; display: boolean }[]): boolean {
    if (modules.length > 0) {
      if (this.modules.length > 0) {
        for (const k in modules) {
          if (this.modules.map(m => m['name']).indexOf(modules[k]['name']) !== -1) {
            // ignore
          } else {
            if (!modules[k]['display']) {
              return false
            }
          }
        }
      }
    }
    return true
  }

  private hasAccessByRole(roles: string[]): boolean {
    return roles.indexOf(this.role) !== -1
  }

  private hasAccessByModules(modules: { name: string; display: boolean }[]): boolean {
    if (modules.length > 0) {
      if (this.modules.length > 0) {
        for (const k in modules) {
          if (this.modules.map(m => m['name']).indexOf(modules[k]['name']) === -1) {
            return false
          }
        }
      }
      return true
    }
    return true
  }

  private getRoles(item: any): string[] {
    let roles: string[] = []
    if (item.roles) {
      roles = item.roles
    }
    return roles
  }

  private getModules(item: any): { name: string; display: boolean }[] {
    let modules: { name: string; display: boolean }[] = []
    if (item.modules) {
      modules = item.modules
    }
    return modules
  }

  ngOnInit(): void {
    this.menuService.getMenuData().subscribe(menuData => (this._menuData = menuData))
    this.activateMenu(this.router.url)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.activateMenu(event.url ? event.url : null)
      })
  }

  private getPathFromURL(url: any) {
    // Query params
    if (url.indexOf('?') !== -1) {
      return url.split('?')[0]
    }
    // Params
    if (url.indexOf(';') !== -1) {
      return url.split(';')[0]
    }
    return url
  }

  private activateMenu(url: any, menuData = this._menuData) {
    this.childrenOfChildren = []
    url = this.getPathFromURL(url)

    menuData = JSON.parse(JSON.stringify(menuData))
    const pathWithSelection = this.getPath({ url: url }, menuData, (entry: any) => entry, 'url')
    if (pathWithSelection) {
      this._menuDataChildrenActivated = pathWithSelection[0].children
      // pathWithSelection.pop().selected = true
      _.each(pathWithSelection, (parent: any) => (parent.open = true))
      for (let i = 0; i < this._menuDataChildrenActivated.length; i++) {
        if (
          url.indexOf(this._menuDataChildrenActivated[i].url) !== -1 &&
          this._menuDataChildrenActivated[i].children
        ) {
          this.childrenOfChildren = this._menuDataChildrenActivated[i].children
        }
      }
      this.menuNotifyService.onChangeMenuEvent(this.childrenOfChildren)
    }
    // this._menuDataActivated = menuData.slice()
  }

  private getPath(
    element: any,
    source: any,
    property: any,
    keyProperty = 'key',
    childrenProperty = 'children',
    path = [],
  ) {
    let found = false
    const getElementChildren = (value: any) => _.get(value, childrenProperty)
    const getElementKey = (value: any) => _.get(value, keyProperty)
    const key = getElementKey(element)
    return (
      _.some(source, (e: any) => {
        if (getElementKey(e) === key || key.indexOf(getElementKey(e)) !== -1) {
          path.push(e)
          return true
        } else {
          return (found = this.getPath(
            element,
            getElementChildren(e),
            property,
            keyProperty,
            childrenProperty,
            path.concat(e),
          ))
        }
      }) &&
      (found || _.map(path, property))
    )
  }
}
